import { render, staticRenderFns } from "./hotelFilters.vue?vue&type=template&id=2f268043"
import script from "./hotelFilters.vue?vue&type=script&lang=js"
export * from "./hotelFilters.vue?vue&type=script&lang=js"
import style0 from "./hotelFilters.vue?vue&type=style&index=0&id=2f268043&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports